<template>
  <div
    :class="rangeStatus ? 'success' : ''"
    class="silder-range"
  >
    <i
      :class="rangeStatus?successIcon:startIcon"
      draggable
      @mousedown="rangeMove"
    />
    {{ rangeStatus ? successText : startText }}
  </div>
</template>

<script>
export default {
  props: {
    // 成功图标
    successIcon: {
      type: String,
      default: 'el-icon-success'
    },
    // 成功文字
    successText: {
      type: String,
      default: '验证成功'
    },
    // 开始的图标
    startIcon: {
      type: String,
      default: 'el-icon-d-arrow-right'
    },
    // 开始的文字
    startText: {
      type: String,
      default: '拖动滑块到最右侧'
    }
  },
  data () {
    return {
      disX: '',
      rangeStatus: false
    }
  },
  methods: {
    rangeMove (e) {
      let ele = e.target
      let startX = e.clientX
      let eleWidth = ele.offsetWidth
      let parentWidth = ele.parentElement.offsetWidth
      let MaxX = parentWidth - eleWidth
      if (this.rangeStatus) {
        return false
      }
      document.onmousemove = (e) => {
        let endX = e.clientX
        this.disX = endX - startX
        if (this.disX <= 0) {
          this.disX = 0
        }
        // 减去滑块的宽度,体验效果更好
        if (this.disX >= MaxX - eleWidth) {
          this.disX = MaxX
        }
        ele.style.transition = '.1s all'
        ele.style.transform = `translateX(${this.disX}px)`
        e.preventDefault()
      }
      document.onmouseup = () => {
        if (this.disX !== MaxX) {
          ele.style.transition = '.5s all'
          ele.style.transform = 'translateX(0)'
          this.$emit('failed', this.rangeStatus)
        } else {
          this.rangeStatus = true
          this.$emit('success', this.rangeStatus)
        }
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.silder-range
  background-color #F4F4F4
  position relative
  transition 1s all
  user-select none
  color #999
  display flex
  justify-content center
  align-items center
  height 40px /* no */
.silder-range i
  position absolute
  left 0
  width 60px /* no */
  height 100%
  color #919191
  background-color #fff
  border 1px solid #ccc
  box-sizing border-box
  cursor pointer
  display flex
  justify-content center
  align-items center
.silder-range.success
  background-color #7AC23C
  color #fff
.silder-range.success i
  color #7AC23C
</style>>
